export enum ResidenceID {
  allFamily = '0', // trattare come 1
  new = '1',
  family = '2',
  domesticPartnership = '3',
}
